import { DownloadOutlined } from '@ant-design/icons';
import { type AllegatoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/allegatoComunicazioneDTO.ts';
import { Button, Tooltip, type UploadFile } from 'antd';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunicationAttachments } from './attachments/useCommunicationAttachmentDownload.ts';

interface AttachmentDownloadIconProps {
  file: UploadFile;
  fileUidMap: Record<string, string>;
  savedAttachmentIds: Set<string>;
}

/**
 * Icona per il download dell'allegato della comunicazione
 */
export function AttachmentDownloadIcon(props: AttachmentDownloadIconProps) {
  const { file, fileUidMap, savedAttachmentIds } = props;

  const { t } = useTranslation();

  const attachmentId = fileUidMap[file.uid] ?? file.uid;
  const canDownload = savedAttachmentIds.has(attachmentId);

  const { download, isFetching } = useCommunicationAttachments({
    attachment: canDownload
      ? ({
          id: attachmentId,
          nomeFile: file.name,
        } as AllegatoComunicazioneDTO)
      : null,
  });

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (isFetching) return;

    download();

    e.preventDefault();
    e.stopPropagation();
  };

  if (!canDownload) {
    return (
      <Tooltip
        title={t(
          'communication-attachment-group-editor.download-after-save',
          'Il download degli allegati appena caricati sarà disponibile dopo il salvataggio della comunicazione.',
        )}
      >
        <Button type="text" size="small" icon={<DownloadOutlined />} disabled />
      </Tooltip>
    );
  }

  return (
    <Button
      type="text"
      size="small"
      icon={<DownloadOutlined />}
      loading={isFetching}
      onClick={handleClick}
    />
  );
}
